import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'

export default class {
  @observable data = {
    userInfo: {},
    thHostGuidId: 0,
    hostGuidIdInfo: {
      medalsIcon: [], 
      avatarurl: "", 
      countryIcon: ""
    }
  }

  @action async GetUserInfoWeb(uid) {
    let d = await http.post('/web/MyAccountInfo', { uid: uid })
    if (d && d.code == 0 && d.res && d.res.uid > 0) {
      this.data.userInfo = d.res
      return d && d.res
    }
  }

  @action async getTiInfo(guild_id) {
    let d = await http.post('/web/guild/info', { guild_id })
    if (d && d.code == 0 && d.res && d.res.countryIcon != "") {
        this.data.hostGuidIdInfo = d.res
    }
  }
}


// WEBPACK FOOTER //
// src/store/app/hobiHost.js